module.exports = __webpack_public_path__ + "static/paint-stain-b664e167021d46a9bc33597202d668ee.png";